import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import { SearchContext } from "../context/SearchContext";
import Grocerylogo from "../images/Grocerylogo.png";
import api from "../utils/api";
const useDebounce = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
};
const menuBtn =
  "btn w-100 text-start fw-semibold d-flex justify-content-between align-items-center py-2";
const Header = () => {
  const drawerRef = useRef(null);
  const startX = useRef(0);
  const currentX = useRef(0);
  const isDragging = useRef(false);
  const productMapRef = useRef({});

  const [cartItems, setCartItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [showSearch, setShowSearch] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const userId = localStorage.getItem("userId");

  const searchContext = useContext(SearchContext);
  const search = searchContext?.search ?? "";
  const setSearch = searchContext?.setSearch ?? (() => {});
  const debouncedSearch = useDebounce(search, 300);
const toggleAccordion = (key) =>
    setOpenAccordion((p) => (p === key ? null : key));

const closeMobileMenuAndGo = (path) => {
  setMobileMenuOpen(false);

  setTimeout(() => {
    navigate(path);
    window.scrollTo(0, 0); // 👈 scroll top
  }, 150);
};

const detectLocation = () => {
    if (!navigator.geolocation) {
      Swal.fire("Error", "Location not supported", "error");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        localStorage.setItem("lat", pos.coords.latitude);
        localStorage.setItem("lng", pos.coords.longitude);
      },
      () => Swal.fire("Error", "Location permission denied", "error")
    );
  };
const fetchCategories = useCallback(async () => {
    try {
      const res = await api.get("/api/products", {
        params: { page: 1, limit: 500 },
      });

      const cats = [
        ...new Set(
          (res.data.products || [])
            .map((p) => p.category)
            .filter(Boolean)
        ),
      ];

      setCategories(cats);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);
useEffect(() => {
    if (!debouncedSearch.trim()) {
      setSuggestions([]);
      return;
    }

    const fetchSearch = async () => {
      try {
        const res = await api.get("/api/products/search", {
          params: { q: debouncedSearch },
        });
        setSuggestions((res.data.products || []).slice(0, 6));
      } catch {
        setSuggestions([]);
      }
    };

    fetchSearch();
  }, [debouncedSearch]);
const loadProductsOnce = useCallback(async () => {
    if (Object.keys(productMapRef.current).length > 0) return;

    const res = await api.get("/api/products", {
      params: { page: 1, limit: 1000 },
    });

    res.data.products.forEach((p) => {
      productMapRef.current[p._id] = p;
    });
  }, []);

const fetchCart = useCallback(async () => {
    if (!userId) return;

    try {
      await loadProductsOnce();

      const cartRes = await api.get(`/api/cart/${userId}`);
      const rawItems = cartRes.data.items || [];

      const merged = rawItems
        .map((ci) => {
          const pid =
            typeof ci.productId === "object"
              ? ci.productId?._id
              : ci.productId;

          const product = productMapRef.current[pid];
          return product
            ? { productId: pid, product, qty: ci.quantity }
            : null;
        })
        .filter(Boolean);

      setCartItems(merged);
    } catch (err) {
      console.error("Fetch cart error:", err);
    }
  }, [userId, loadProductsOnce]);

  useEffect(() => {
    fetchCart();
    window.addEventListener("cartUpdated", fetchCart);
    return () =>
      window.removeEventListener("cartUpdated", fetchCart);
  }, [fetchCart]);
const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    currentX.current = startX.current;
    isDragging.current = true;
  };

  const onTouchMove = (e) => {
    if (!isDragging.current || !drawerRef.current) return;

    currentX.current = e.touches[0].clientX;
    const diff = currentX.current - startX.current;

    if (diff > 0) {
      drawerRef.current.style.transform = `translateX(${diff}px)`;
    }
  };

  const onTouchEnd = () => {
    const diff = currentX.current - startX.current;
    if (diff > 80) setMobileMenuOpen(false);
    else if (drawerRef.current)
      drawerRef.current.style.transform = "translateX(0)";
    isDragging.current = false;
  };
const SearchBox = ({ onSelect }) => (
    <div className="position-relative w-100">
      <input
        className="form-control"
        placeholder="Search products..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {suggestions.length > 0 && (
        <ul className="list-group position-absolute w-100 shadow">
          {suggestions.map((p) => (
            <li
              key={p._id}
              className="list-group-item list-group-item-action"
              onClick={() => {
                onSelect(p._id);
                setSuggestions([]);
              }}
            >
              {p.name} — ₹{p.price}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

return (
    <>
      {/* ================= TOP BAR ================= */}
      <div className="bg-light py-1 border-bottom">
        <div className="container">
          Super Value Deals - Save more with coupons
        </div>
      </div>

      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
        <div className="container">
          <img
            src={Grocerylogo}
            width={180}
            alt="logo"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/")}
          />

          <button
            className="navbar-toggler d-lg-none"
            onClick={() => setMobileMenuOpen(true)}
          >
            ☰
          </button>

          {/* ===== DESKTOP MENU ===== */}
          <div className="collapse navbar-collapse d-none d-lg-block">
            <ul className="navbar-nav ms-auto">
            

              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="#"
                  data-bs-toggle="dropdown"
                >
                  About
                </Link>
                <ul className="dropdown-menu">
                  <Link className="dropdown-item" to="/AboutUs">
                    About Us
                  </Link>
                  <Link className="dropdown-item" to="/Contact">
                    Contact
                  </Link>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="#"
                  data-bs-toggle="dropdown"
                >
                  Shop
                </Link>
                <ul className="dropdown-menu">
                  <Link className="dropdown-item" to="/Shop">
                    Shop
                  </Link>
                  <Link className="dropdown-item" to="/ShopWishList">
                    Wishlist
                  </Link>
                  <Link className="dropdown-item" to="/ShopCart">
                    Cart
                  </Link>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="#"
                  data-bs-toggle="dropdown"
                >
                  Account
                </Link>
                <ul className="dropdown-menu">
                  <Link className="dropdown-item" to="/MyAccountSignIn">
                    Sign In
                  </Link>
                  <Link className="dropdown-item" to="/MyAccountSignUp">
                    Signup
                  </Link>
                  <Link className="dropdown-item" to="/my-orders">
                    Orders
                  </Link>
                  <Link className="dropdown-item" to="/MyAccountSetting">
                    Settings
                  </Link>
                  <Link className="dropdown-item" to="/profile">
                    profile 
                  </Link>
                </ul>
              </li>
            </ul>
          </div>

          {/* ===== DESKTOP ICONS ===== */}
          <div className="d-none d-lg-flex gap-3 align-items-center ms-3">
            <Link to="/ShopWishList">❤️</Link>
            <Link to="/MyAccountSignIn">👤</Link>
            <Link to="/ShopCart">
              🛍️{" "}
              {cartItems.reduce(
                (sum, item) => sum + Number(item.qty || 0),
                0
              )}
            </Link>
          </div>
        </div>
      </nav>

      {/* ================= MOBILE DRAWER ================= */}
      {mobileMenuOpen && (
        <div
          ref={drawerRef}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "78vw",
            maxWidth: 360,
            height: "100vh",
            background: "#fff",
            zIndex: 9999,
            overflowY: "auto",
            borderTopRightRadius: 18,
            borderBottomRightRadius: 18,
            boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
          }}
        >
          {/* ===== DRAWER HEADER ===== */}
          <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
            <div>
              <div className="fw-bold fs-5">🛒 FreshCart</div>
              <small className="text-muted">
                Groceries delivered fast
              </small>
            </div>
            <button
              className="btn-close"
              onClick={() => setMobileMenuOpen(false)}
            />
          </div>

          {/* ===== DRAWER CONTENT ===== */}
          <div className="p-3">
            {/* SEARCH */}
            <div className="bg-light rounded-3 p-3 mb-3 shadow-sm">
              <button
                className="btn btn-outline-success w-100 mb-2 fw-semibold"
                onClick={() => setShowSearch(!showSearch)}
              >
                🔍 Search Products
              </button>

              {showSearch && (
                <SearchBox
                  onSelect={(id) => {
                    closeMobileMenuAndGo(`/product/${id}`);
                    setShowSearch(false);
                  }}
                />
              )}
            </div>

            <button
              className="btn btn-success w-100 py-2 fw-semibold mb-2"
              onClick={() => closeMobileMenuAndGo("/Shop")}
            >
              🛍 Start Shopping
            </button>

            <button
              className="btn btn-outline-secondary w-100 py-2 mb-3"
              onClick={detectLocation}
            >
              📍 Pick Delivery Location
            </button>

            <hr />

            {/* DEPARTMENTS */}
            <button
              className={menuBtn}
              onClick={() => toggleAccordion("departments")}
            >
              📦 All Departments
            </button>

            {openAccordion === "departments" && (
              <div className="ps-3">
                {categories.map((cat, i) => (
                  <button
                    key={i}
                    className="btn btn-link d-block text-start"
                    onClick={() =>

                      closeMobileMenuAndGo(
                        `/Shop?category=${encodeURIComponent(cat)}`
                      )
                    }
                  >
                    {cat}
                  </button>
                ))}
              </div>
            )}

            <hr />

            {/* QUICK LINKS */}
            <button
              className={menuBtn}
              onClick={() => closeMobileMenuAndGo("/")}
            >
              🏠 Home
            </button>

            <button
              className={menuBtn}
              onClick={() => closeMobileMenuAndGo("/ShopCart")}
            >
              🛒 Cart
            </button>

            <button
              className={menuBtn}
              onClick={() => closeMobileMenuAndGo("/my-orders")}
            >
              🚚 My ORDER 
            </button>

            <button
              className={menuBtn}
              onClick={() => closeMobileMenuAndGo("/MyAccountSignIn")}
            >
             👤 Login / Register
            </button>


{/* ACCOUNT */}
            <button
              className={menuBtn}
              onClick={() => toggleAccordion("account")}
            >
              ⚙️ Setting 
            </button>

            {openAccordion === "account" && (
              <div className="ps-3">
                <button
                  className="btn btn-link d-block text-start"
                  onClick={() =>
                    closeMobileMenuAndGo("/MyAccountSignIn")
                  }
                >
                  Sign In
                </button>
                <button
                  className="btn btn-link d-block text-start"
                  onClick={() =>
                    closeMobileMenuAndGo("/MyAccountSignUp")
                  }
                >
                  Signup
                </button>
                <button
                  className="btn btn-link d-block text-start"
                  onClick={() =>
                    closeMobileMenuAndGo("/my-orders")
                  }
                >
                  Orders
                </button>
                <button
                  className="btn btn-link d-block text-start"
                  onClick={() =>
                    closeMobileMenuAndGo("/MyAccountSetting")
                  }
                >
                  Settings
                </button>
<button
                  className="btn btn-link d-block text-start"
                  onClick={() =>
                    closeMobileMenuAndGo("/profile")
                  }
                >
                  profile 
                </button>
              </div>
            
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Header;